// Notifications removed for organizations
import { resetThunk as resetLogin } from 'actions/login/OrganizationsLoginActions';
import { reset as resetMarketplace } from '@spike/marketplace-action';
import { fetchMasterDataWithoutMarketplaceThunk, reset as resetMasterdata } from '@spike/masterdata-action';
import ApiClient from 'api/ApiClient';
import { Dispatch } from 'redux';

// Clean all state for organizations (minimal)
export const cleanAll = (dispatch: Dispatch<any>, avoidFetchingMasterData?: boolean) => {
    dispatch(resetLogin());
    cleanAllExceptLogin(dispatch, avoidFetchingMasterData);
};

export const cleanAllExceptLogin = (dispatch: Dispatch<any>, avoidFetchingMasterData?: boolean) => {
    // No notifications reset needed for organizations
    dispatch(resetMarketplace());
    dispatch(resetMasterdata());
    
    // Fetch master data if needed
    !avoidFetchingMasterData && dispatch(fetchMasterDataWithoutMarketplaceThunk(ApiClient));
};